import React from "react";

export default function AdminListPagination({
  page,
  pages,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  testId,
  itemLabel = "items",
}) {
  const firstItem = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const lastItem = Math.min(page * pageSize, total);

  return (
    <div className="admin-list-pagination">
      <span className="text-muted fs-12" data-testid={`${testId}-summary`}>
        {total ? `Showing ${firstItem}–${lastItem} of ${total.toLocaleString("en-IN")} ${itemLabel}` : `No ${itemLabel}`}
      </span>
      <label className="admin-list-page-size">
        <span className="text-muted fs-12">Rows</span>
        <select
          className="field-input"
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
          aria-label={`Rows per page for ${itemLabel}`}
          data-testid={`${testId}-page-size`}
        >
          {[25, 50, 100].map((size) => <option key={size} value={size}>{size}</option>)}
        </select>
      </label>
      <div className="admin-list-pagination-controls">
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          data-testid={`${testId}-prev`}
        >
          Previous
        </button>
        <span className="text-muted fs-12" aria-current="page">{pages > 0 ? `Page ${page} of ${pages}` : "Page 1 of 1"}</span>
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
          data-testid={`${testId}-next`}
        >
          Next
        </button>
      </div>
    </div>
  );
}
